import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import type { ContentStatus } from '../constants/ContentStatus';
import { getQuerySingleContentStatusArrayVariable } from '../utils/getQuerySingleContentStatusArrayVariable';
import useContentClassificationContentDataClassificationQuery, {
	type useContentClassificationContentDataClassificationQuery$data,
	type useContentClassificationContentDataClassificationQuery$variables,
} from '../hooks/__generated__/useContentClassificationContentDataClassificationQuery.graphql';

export function preloadContentDataClassification(contentId: string, contentStatus: ContentStatus) {
	return query<
		useContentClassificationContentDataClassificationQuery$data,
		useContentClassificationContentDataClassificationQuery$variables
	>({
		query: useContentClassificationContentDataClassificationQuery,
		variables: {
			contentId,
			lowerCaseContentStatusArray: getQuerySingleContentStatusArrayVariable([contentStatus]),
		},
	});
}
